import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
import { ArrowRightIcon } from 'lucide-react';
export function UseCases() {
  const {
    t
  } = useLanguage();
  const cases = [{
    image: 'https://cdn.magicpatterns.com/uploads/mHDwaFKTHo2wtmBMNxAV61/Shakshouka_x_ENERGY_blend_.png',
    tag: t('useCases.case1.tag'),
    title: t('useCases.case1.title'),
    description: t('useCases.case1.description'),
    product: t('useCases.case1.product'),
    alt: 'NeuroSpice Energy blend poured from the tin over shakshouka in a cast iron pan'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/8jJPEiv5FYhV4cY6cG9iVp/Virgin_Mary_x_REST_Blend_.png',
    tag: t('useCases.case2.tag'),
    title: t('useCases.case2.title'),
    description: t('useCases.case2.description'),
    product: t('useCases.case2.product'),
    alt: 'Virgin Mary glass rimmed with NeuroSpice Rest salt and reishi, with the Rest tin behind'
  }];
  return <section className="w-full py-24 px-6 bg-white border-t-2 border-black" data-id="element-433" data-mp="2rsmh9rtjwi2b">
      <div className="max-w-6xl mx-auto" data-id="element-434" data-mp="2wubu9d0c35t1">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-435" data-mp="2wr7jtxw9zdtx">
          <div className="inline-block px-4 py-1 border border-black text-xs font-mono tracking-wider uppercase mb-6" data-id="element-436" data-mp="3fk1o9xw9vnjw">
            {t('useCases.badge')}
          </div>
          <h2 className="text-5xl md:text-7xl font-black text-black mb-6 uppercase tracking-tighter leading-none" style={{
          fontFamily: 'system-ui, -apple-system, sans-serif',
          fontStretch: 'condensed'
        }} data-id="element-437" data-mp="35tywg10w0fn5">
            {t('useCases.title')}
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-438" data-mp="c15k3bqfayes">
            {t('useCases.subtitle')}
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-439" data-mp="8021wikwkqae">
          {cases.map((c, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.15
        }} className="group relative border-2 border-black overflow-hidden bg-white" data-id="element-440" data-mp="32acbv7qdg9d" data-mpi={index}>
              {/* Image */}
              <div className="relative aspect-[4/3] overflow-hidden bg-gray-100" data-id="element-441" data-mp="36fux55xt1bkm">
                <img src={c.image} alt={c.alt} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-442" data-mp="31hbbz7r1c3tb" />
                <div className="absolute top-4 left-4 px-3 py-1 bg-black text-white text-xs font-black uppercase tracking-wider" data-id="element-443" data-mp="2wby1y11d0wyj">
                  {c.tag}
                </div>
              </div>

              {/* Content */}
              <div className="p-6 border-t-2 border-black" data-id="element-444" data-mp="36anc17n0ld48">
                <div className="text-xs font-mono uppercase tracking-widest text-gray-500 mb-2" data-id="element-445" data-mp="28o6djz2jotgw">
                  {c.product}
                </div>
                <h3 className="text-2xl md:text-3xl font-black uppercase tracking-tight mb-3" style={{
              fontFamily: 'system-ui, -apple-system, sans-serif',
              fontStretch: 'condensed'
            }} data-id="element-446" data-mp="2dkdltyieyh20">
                  {c.title}
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed" data-id="element-447" data-mp="1uvgoflrpz8fk">
                  {c.description}
                </p>
              </div>
            </motion.div>)}
        </div>

        {/* B2B Teaser */}
        <motion.a href="mailto:hello@thisisneurospice.com?subject=Bulk%20%2F%20B2B%20Enquiry" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="block group border-2 border-black p-6 md:p-8 bg-black text-white hover:bg-white hover:text-black transition-colors duration-300" data-id="element-448" data-mp="3rn4e6vvc8dck">
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4" data-id="element-449" data-mp="o5m74qne3ad7">
            <div className="flex-1" data-id="element-450" data-mp="2uvairhkcvcn9">
              <div className="text-xs font-mono uppercase tracking-widest opacity-70 mb-2" data-id="element-451" data-mp="2uwc4cfyzzhj8">
                {t('useCases.b2b.tag')}
              </div>
              <h3 className="text-2xl md:text-3xl font-black uppercase tracking-tight mb-1" style={{
              fontFamily: 'system-ui, -apple-system, sans-serif',
              fontStretch: 'condensed'
            }} data-id="element-452" data-mp="15eyivaowpzd9">
                {t('useCases.b2b.title')}
              </h3>
              <p className="text-sm opacity-80" data-id="element-453" data-mp="10mdpga9wxoa9">
                {t('useCases.b2b.description')}
              </p>
            </div>
            <div className="flex items-center gap-2 text-sm font-black uppercase tracking-widest whitespace-nowrap" data-id="element-454" data-mp="mqjr2l6rmhbe">
              {t('useCases.b2b.cta')}
              <ArrowRightIcon className="w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-455" data-mp="crb081775it9" />
            </div>
          </div>
        </motion.a>
      </div>
    </section>;
}